/* eslint-disable jsx-a11y/anchor-is-valid */
import "../../../../app/assets/sass/_variables.scss";
import clsx from "clsx";
import { HeaderUserMenu } from "../../../partials";
import { useLayout } from "../../core";
import { DefaultTitle } from "../header/page-title/DefaultTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-solid-svg-icons";
import { KTSVG } from "../../../helpers";
import { CPLModule } from "app/modules/shared/cplModules/CPLModule";
import { CPLModules } from "cpl-react-common/components/Enums/CPLModules";
import AIAssistantBadge from "app/modules/aiAssistant/popup/AIAssistantBadge";
import BackgroundActivityBadge from "app/modules/backgroundActivities/components/BackgroundActivityBadge";

const toolbarUserAvatarHeightClass = "symbol-30px symbol-md-40px";

const Toolbar = ({ externalAccess = false }: { externalAccess?: boolean }) => {
  const { classes, config } = useLayout();
  const { aside } = config;

  return (
    <>
      <div id="kt_toolbar" className={clsx("header", classes.header.join(" "), "align-items-stretch")}>
        {/* begin::Container */}
        <div
          id="kt_toolbar_container"
          className={clsx(classes.toolbarContainer.join(" "), "d-flex flex-stack justify-content-between")}
        >
          {/* begin::Aside mobile toggle */}
          {aside.display && (
            <div className="d-flex align-items-center d-lg-none ms-n3 me-1" title="Show aside menu">
              <div
                className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
                id="kt_aside_mobile_toggle"
              >
                <KTSVG
                  path="/media/icons/duotune/abstract/abs015.svg"
                  className="svg-icon-2x mt-1"
                  color="var($cpl-primary)"
                />
              </div>
            </div>
          )}
          {/* end::Aside mobile toggle */}
          <DefaultTitle />
          {!externalAccess && (
            <>
              {/* begin::Actions */}
              <div className="d-flex align-items-end ms-auto">
                {/* begin::Button */}
                <CPLModule module={CPLModules.AIAssistant}>
                  <AIAssistantBadge />
                </CPLModule>
                <BackgroundActivityBadge />
                <div
                  className={clsx("btn btn-icon", toolbarUserAvatarHeightClass)}
                  data-kt-menu-trigger="click"
                  data-kt-menu-attach="parent"
                  data-kt-menu-placement="bottom-end"
                  data-kt-menu-flip="bottom"
                >
                  <FontAwesomeIcon icon={faUser} size="xl" style={{ color: "var($cpl-primary)" }} />
                </div>
                <HeaderUserMenu />
              </div>
              {/* end::Button */}
              {/* end::Actions */}
            </>
          )}
        </div>
        {/* end::Container */}
      </div>
    </>
  );
};

export { Toolbar };
